import React from 'react';
import { Icon } from 'infl-icons';
import { withNamespaces } from 'react-i18next';
import cn from 'classnames';

import { qaSel } from '../../common/utils';
import actionCenterStyles from '../action-center/style.css';
import styles from './style.css';

const Points = ({ value, onClick, t }) => (
  <a
    data-qa={qaSel('rewards')}
    className={cn(actionCenterStyles.iconLink, 'c-link c-points')}
    href="/rewards"
    onClick={onClick}>
    <div className={cn(styles.points, 'c-icon-wrapper')}>
      <Icon icon="coins" title={t('Your points balance')} />
      <div className={cn(styles.pointsAmt, 'c-points-balance')}>
        {value.toLocaleString()}
      </div>
    </div>
  </a>
);

export default withNamespaces()(Points);
